import ActivityTracker from '../services/ActivityTracker'

export function pwaInstallEvent () {
  window.onappinstalled = function (ev) {
    const activityLog = new ActivityTracker()
    activityLog.addEvent('Viewed PWA Install Instructions', {}, false)
  }
}
